import React, { useRef, useState } from 'react';
import './FormContactsNew.scss';
import './FormContactsNew-media.scss';
import '../../services/CssTransitionModal.scss';
import Input from '../Input/Input';
import InputPhone from '../Input/InputPhone';
import Button from '../Button/Button';
import { ServiceData } from '../../redux/services/ServiceRedux';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import ErrorText from '../ErrorText/ErrorText';
import { AdaptiveValue, MediaContent, ValidationFormItems } from '../../services/GlobalFunctions';
import { LinkTg } from '../../services/content/Constants';
import { Props } from './interfaces';
import { SvgTg } from './constants';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { CSSTransition } from 'react-transition-group';
import SuccessContent from '../SuccessContent/SuccessContent';
import {content} from "../../services/content";
import AgreementCheckboxes from "../AgreementCheckboxes/AgreementCheckboxes";
import ErrorTextBlocked from "../ErrorTextBlocked/ErrorTextBlocked";

const FormContactsNew = ({
  title = 'Остались вопросы?',
  subTitle = 'Dalli всегда рядом',
  buttonText = 'Отправить',
  image,
  imageText,
  widthRight,
  telegram = false,
  blockedSend,
  blockedSendLoaded,
  widthWindow,
  eventMetrika,
  recaptchaV2ref,
  contactForms,
}: Props) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('+7');
  const [successShow, setSuccessShow] = useState(false);
  const [errorPhone, setErrorPhone] = useState<string | null>(null);
  const [serverText, setServerText] = useState<string | null>(null);
  const [disableBtn, setDisableBtn] = useState(false);
  const [showBlockedError, setShowBlockedError] = useState(false);

  const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);
  const [allowMarketing, setAllowMarketing] = useState(false);

  const success = () => {
    setName('');
    setPhone('+7');
    setSuccessShow(true);
    if (typeof ym !== 'undefined') {
      ym(26501373, 'reachGoal', 'feedback_success');
    }
    setDisableBtn(false);
    setPrivacyPolicyAccepted(false); // Reset checkbox
    setAllowMarketing(false);       // Reset checkbox
    setErrorPhone(null);            // Clear phone error
    setServerText(null);            // Clear server error
  };

  const OnTimeOut = () => {
    setTimeout(() => setSuccessShow(false), 3000);
  };

  const { executeRecaptcha } = useGoogleReCaptcha(); // v3

  const handleReCaptchaVerify = async (e: any) => {
    e.preventDefault();
    setDisableBtn(true);
    setErrorPhone(null);
    setServerText(null);

    setShowBlockedError(false);
    if (blockedSend.state) {
      setShowBlockedError(true);
      setDisableBtn(false);
      return;
    }

    // v3
    let token = '';
    if (!executeRecaptcha) {
      console.debug('recaptcha not set, ignoring');
    } else {
      token = await executeRecaptcha(); // v3
    }

    if (!ValidationFormItems({ phone, setErrorPhone })) {
      setDisableBtn(false);
      return;
    }
    ServiceData.submitForm({
      data: {
        name,
        phone,
        allowMarketing
      },
      success,
      setServerText,
      token,
      blockedSendLoaded,
      eventMetrika,
      contactFormId: contactForms.new_contact_form_id // Ensure this ID is correct
    });
  };

  const widthR = widthRight ? AdaptiveValue({ widthWindow, value: widthRight }) : 'auto';

  const nodeRefSuccess = useRef(null);
  const nodeRef = useRef(null);

  return (
    <>
      <div className="form-contacts-new">
        <CSSTransition
          in={successShow}
          nodeRef={nodeRefSuccess}
          timeout={{ appear: 200, enter: 0, exit: 200 }}
          classNames="css-transition-modal"
          unmountOnExit
          onEnter={OnTimeOut}
        >
          <SuccessContent refCss={nodeRefSuccess} />
        </CSSTransition>

        <CSSTransition
          in={!successShow}
          nodeRef={nodeRef}
          timeout={{ appear: 200, enter: 0, exit: 0 }}
          classNames="css-transition-content"
          unmountOnExit
        >
          <div
            ref={nodeRef}
            className="form-contacts-new__block"
            style={widthRight ? { gridTemplateColumns: `auto ${widthR}` } : {}}
          >
            <div className="form-contacts-new__block-header">
              {!image ? (
                <>
                  <div className="form-contacts-new__block-title">
                    <h2 className="form-contacts-new__title">{title}</h2>
                    <p className="body1">{subTitle}</p>
                  </div>

                  <div>
                    {telegram ? (
                      <a href={LinkTg} target="_blank" className="form-contacts-new__soc" rel="nofollow">
                        {SvgTg}
                      </a>
                    ) : null}
                  </div>
                </>
              ) : (
                MediaContent(
                  <>
                    <img src={image} className="form-contacts-new__image" alt="form" />
                    {imageText ? (
                      <div
                        className="form-contacts-new__image-text"
                        dangerouslySetInnerHTML={{ __html: imageText }}
                      ></div>
                    ) : null}
                  </>,
                  null
                )
              )}
            </div>

            <form onSubmit={handleReCaptchaVerify}>
              {image ? (
                <div className="form-contacts-new__block-title">
                  <h2 className="form-contacts-new__title">{title}</h2>
                  <p className="body1">{subTitle}</p>
                </div>
              ) : null}

              <Input
                label={content.formContacts.inputName}
                name="name"
                value={name}
                onChange={(e: any) => setName(e.target.value)}
                error={null}
                marginTop={0}
              />

              <InputPhone
                label={content.formContacts.inputPhone}
                name="phone"
                value={phone}
                onChange={(e: any) => {
                  setPhone(e.target.value);
                  if (errorPhone) setErrorPhone(null);
                  if (serverText) setServerText(null);
                }}
                error={errorPhone}
              />

              {showBlockedError && blockedSend.state && (
                <div className="form-contacts-new__error-blocked">
                  <ErrorTextBlocked counter={blockedSend.counter} />
                </div>
              )}

              <AgreementCheckboxes
                privacyChecked={privacyPolicyAccepted}
                onPrivacyChange={setPrivacyPolicyAccepted}
                marketingChecked={allowMarketing}
                onMarketingChange={setAllowMarketing}
              />

              <div className="form-contacts-new__button">
                {serverText && !errorPhone ? ErrorText(serverText, true) : null}
                <Button
                  text={buttonText}
                  widthAll
                  disabled={disableBtn || !privacyPolicyAccepted}
                  showBlockedError={showBlockedError}
                />
              </div>
            </form>
          </div>
        </CSSTransition>
      </div>
      <div className="form-contacts-new__bg"></div>
    </>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(FormContactsNew));
